<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <ConfirmationDialog2 ref="confirmationDialog" />
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>{{ $t('StationDetailModify.editTitleMsg') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close()" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <MetadataForm ref="form" :station="station" :metadata="metadata" />
      </v-card-text>
      <v-card-actions>
        <v-btn outline :loading="loading.remove" class="tertiary" color="error" @click="remove()">
          <v-icon>delete_forever</v-icon>
          {{ $t('Button.Remove') }}
        </v-btn>
        <v-spacer />
        <v-btn color="success" :loading="loading.submit" @click.native="submit()">
          <v-icon>done</v-icon>
          {{ $t('Button.Save') }}
        </v-btn>
        <v-btn outline color="secondary" @click.native="close()">{{ $t('Button.Close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import MetadataForm from './MetadataForm'

  const stationmetadata = createNamespacedHelpers('stationmetadata')
  const app = createNamespacedHelpers('app')

  export default {
    components: {
      MetadataForm,
    },
    props: {
      station: Object,
      metadata: Array,
    },
    data() {
      return {
        dialog: false,
        loading: {
          submit: false,
          remove: false,
        },
      }
    },
    computed: {
      ...stationmetadata.mapGetters(['stationMetadata']),
    },
    methods: {
      ...stationmetadata.mapActions(['deleteMetaData', 'upsertMetadata']),
      ...app.mapActions(['setSnackbar']),
      async show(metadatum) {
        this.dialog = true

        await this.$nextTick()
        this.$refs.form.initialize(metadatum)
      },
      close() {
        this.dialog = false
      },
      async submit() {
        this.loading.submit = true
        if (!this.$refs.form.validate()) return
        let payload = this.$refs.form.payload

        try {
          await this.upsertMetadata(payload)

          this.setSnackbar({
            text: this.$t('StationDetailModify.updateSuccessMsg', {
              msg: payload.Field,
            }),
            color: 'success',
            icon: 'done',
          })

          this.$emit('refresh')

          this.close()
        } catch (error) {
          this.setSnackbar({
            text: error,
            color: 'error',
            icon: 'error',
          })
        }

        this.loading.submit = false
      },
      async remove() {
        this.loading.remove = true

        let metadatum = this.$refs.form.payload

        let confirmParams = {
          title: 'Remove metadata',
          text: `Are you sure you want to remove the '${metadatum.Field}' metadata?`,
          confirmText: 'Remove',
          cancelText: 'Cancel',
          color: 'error',
          icon: 'delete_forever',
        }

        let confirmed = await this.$refs.confirmationDialog.confirm(confirmParams)
        if (!confirmed) {
          this.loading.remove = false
          return
        }

        try {
          await this.deleteMetaData(metadatum.Id)

          this.setSnackbar({
            text: this.$t('StationDetailModify.deleteSuccessMsg', {
              msg: metadatum.Field,
            }),
            color: 'success',
            icon: 'done',
          })

          this.$emit('refresh')
          this.close()
        } catch (error) {
          this.setSnackbar({
            text: error,
            color: 'error',
            icon: 'error',
          })
        }

        this.loading.remove = false
      },
    },
  }
</script>